import * as React from 'react'
import styled from 'styled-components'
import media from '../../../../services/generateMediaQueries'

import AddCardPageForm from '../../containers/AddCardPageForm'
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'
import ZingIcon from '../../../../assets/img/zing-icon.svg'

export const MainPage = styled.div`
  display: ${props => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`

export const Header = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
  background: var(--color-primary);

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: url('${MoreHeaderParticles}');
    background-repeat: no-repeat;
    background-position: right top;
  }
`

export const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

export const Title = styled.h1`
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

export const Content = styled.div`
  flex: 1 1 auto;
  padding: 2rem 0;
  overflow: auto;
`

export const DetailPageContainer = styled.div`
  display: ${props => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  background-color: inherit;
  transition-property: width;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-linear);
  overflow: hidden;
  height: 100vh;
`

export const ErrorMessage = styled.p`
  padding: 0.59375rem 1rem;
  position: relative;
  margin-top: 0;
  margin-bottom: 0.625rem;
  font-size: 0.875rem;
  transition-property: padding, margin;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);
  overflow: hidden;

  &::before {
    content: ' ';
    display: block;
    border-radius: var(--border-radius-form);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--color-error);
    opacity: 0.1;
  }

  &:empty {
    padding-top: 0;
    padding-bottom: 0;
    margin: 0;
  }
`

export const BannerAdsContainer = styled.div`
  overflow: hidden;
  margin-bottom: 1rem;
`

export const BannerAdContainer = styled.div`
  width: 100%;
  padding: 0 0.35rem;
`
export const BannerAd = styled.img`
  object-fit: cover;
  height: 13rem;
  width: 19.5rem;
  border-radius: var(--border-radius-button);

  ${media.lessThan('small')`
  height: 55vw;
  width: 82.5vw;
  `}
`
export const ZingIconComponent = styled.img.attrs({ src: ZingIcon })`
  margin-bottom: 1rem;
`
export const BannerCardContainer = styled.div`
  margin: 0 0.35rem;
  height: 13rem;
  width: 19.5rem;
  border-radius: var(--border-radius-button);
  background-color: rgba(141, 122, 157, 0.4);
  display: grid;
  place-content: center;

  ${media.lessThan('small')`
  height: 55vw;
  width: 82.5vw;
  `}
`

export const Text = styled.p`
  margin: 0;
  color: #ffffff;
  font-weight: 500;
  text-align: center;
`

export const StyledAddCardPageForm = styled(AddCardPageForm)`
  padding: 0 1.1875rem;
`

export const LoadingBannerAdCard = ({ error, onRetry }) => (
  <BannerCardContainer onClick={error ? onRetry : e => e.preventDefault()}>
    <ZingIconComponent />
    {error && (
      <>
        <Text>Failed to load Banner Ads.</Text>
        <Text>Tap to retry.</Text>
      </>
    )}
  </BannerCardContainer>
)

export const PageContent = styled.div`
  padding: 0 1.1875rem;
`
